import { render, staticRenderFns } from "./NewsMultipleJyh.vue?vue&type=template&id=15e3ecbd&scoped=true&"
import script from "./NewsMultipleJyh.vue?vue&type=script&lang=ts&"
export * from "./NewsMultipleJyh.vue?vue&type=script&lang=ts&"
import style0 from "./NewsMultipleJyh.vue?vue&type=style&index=0&id=15e3ecbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e3ecbd",
  null
  
)

export default component.exports